// @ts-strict-ignore
import {ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LMFieldBaseComponent } from '@field/lm-field-base.component';
import { LMModel } from '@form/model';
import { LMFieldServiceAdapter } from '@field/lm-field-service-adapter';
import { LMContextService } from '@app/services';
import { LMContextUtilService } from "@app/utils";

enum LMTextAreaTypeDisplayEnum {
  PLAIN = 0,
  DISPLAY_AS_TEXT,
}

@Component({
  selector:    'lm-textarea',
  templateUrl: './lm-textarea.component.html',
  styleUrls:   [ 'lm-textarea.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMTextareaComponent extends LMFieldBaseComponent implements OnInit, OnDestroy {

  @ViewChild('Input', { read: ElementRef }) inputElement: ElementRef;

  @HostBinding('attr.data-automation-id') dataFieldAutomationId = '';

  @Input() layoutObject: LMFormLayoutField;
  @Input() specFields: LMSpecFields;
  @Input() model: LMModel;

  public rows: number = undefined;

  public displayType: LMTextAreaTypeDisplayEnum;
  public layoutDisplayType;
  public showBarCodeIcon = false;

  constructor(
    protected lmFieldServiceAdapter: LMFieldServiceAdapter,
    protected lmContextUtilService: LMContextUtilService,
    private lmContextService: LMContextService
  ) {
    super(lmFieldServiceAdapter);
    this.layoutDisplayType = LMTextAreaTypeDisplayEnum;
  }

  // events
  ngOnInit() {
    super.ngOnInit();
    this.initialize(this.layoutObject, this.specFields, this.model);

    // see JFieldClobTextArea > DEFAULT_TEXTAREA_LINES
    this.rows = (this.layoutObject.lines === undefined || this.layoutObject.lines === 0) ? 4 : this.layoutObject.lines;

    if (this.specField.isLpl) {
      this._fieldClassArray.push('lm-monospace');
    }

    if (this.displayAsText) {
      this.displayType = this.layoutDisplayType.DISPLAY_AS_TEXT;
      this._fieldClassArray.push('lm-text-data hide-white-space');

    } else {
      this.displayType = this.layoutDisplayType.PLAIN;
      if (this.field.scannable && this.lmContextService.insideInforGo()) {
        this.showBarCodeIcon = true;
      }

      this.subscribeToInlineError();
    }

    this.setSize();
    this.setFieldClasses();

    this.dataFieldAutomationId = `lm-${this.fieldAutomationId}-field`;
    // currently no options are needed
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  contextMenuClicked = ($event) => {
    this.onContextMenuEvent($event);
  }

  private getTextInputElement() {
    return (this.inputElement && this.inputElement.nativeElement)
      ? this.inputElement.nativeElement
      : this.inputElement && this.inputElement[ 'element' ].nativeElement
        // SohoInputComponent
        ? this.inputElement[ 'element' ].nativeElement
        : undefined;
  }

  onBarCodeClick = () => {
    if (this.lmContextService.insideInforGo() && !this.lmContextService.isMobileDevice()) {
      // &contentContainer=InforGo to url in browser to get the insideInforGo to equal true.
      const test = '';
      this.processBarCodeClick(test);
    } else {
      this.lmContextUtilService.showQRCodeScanner().subscribe((response: LMBarCodeData) => {
        if (response?.data) {
          this.processBarCodeClick(response?.data);
        }
      });
    }
  };

  processBarCodeClick = (scanResults) => {
    const lmScannableFieldInfo: LMModelFieldInfo = this.lmFieldServiceAdapter.lmGlobalUtilService.callScannableParse(scanResults, this.field?.scannableName);

    const inputElement = this.getTextInputElement();
    if (inputElement) {
      inputElement.focus();
      document.execCommand('insertText', false, scanResults);
    }
  };
}
